import * as React from 'react';
import { Link } from 'react-router-dom';
import Title from '../components/Title';

export interface IErrorPageProps {}

interface IErrorPageState {
    height: number;
}
export default class ErrorPage extends React.Component<
    IErrorPageProps,
    IErrorPageState
> {
    constructor(props: IErrorPageProps) {
        super(props);
        this.state = {
            height: 600
        };
    }

    componentWillMount() {
        this.setState({
            height: window.innerHeight - 320
        });
    }

    render() {
        return (
            <div className="errorPage" style={{ minHeight: this.state.height }}>
                <Title />

                <div className="wrapper">
                    <h1>The page you are trying to reach does not exist</h1>
                    <p>
                        Please double-check the address. In case you are using a
                        sharing token to link a new shared dive with your
                        account, please verify that you have copied the whole
                        URL and pasted it into your address bar. If you believe
                        that the address is correct, please contact us at{' '}
                        <Link to="mailto:support@wetnotes.com">
                            support@wetnotes.com
                        </Link>.
                    </p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ErrorPage.tsx